import { render, staticRenderFns } from "./TechnicalManager.vue?vue&type=template&id=64107726&scoped=true&"
import script from "./TechnicalManager.vue?vue&type=script&lang=js&"
export * from "./TechnicalManager.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalManager.vue?vue&type=style&index=0&id=64107726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64107726",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VDataTable,VSelect})
